import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidIBAN } from 'ibantools';
import { normalizeIban } from './validation.utils';

const IBAN_LENGTHS_BY_COUNTRY: Record<string, number> = {
  AL: 28,
  AD: 24,
  AT: 20,
  AZ: 28,
  BH: 22,
  BE: 16,
  BA: 20,
  BR: 29,
  BG: 22,
  CR: 22,
  HR: 21,
  CY: 28,
  CZ: 24,
  DK: 18,
  DO: 28,
  EE: 20,
  FO: 18,
  FI: 18,
  FR: 27,
  GE: 22,
  DE: 22,
  GI: 23,
  GR: 27,
  GL: 18,
  GT: 28,
  HU: 28,
  IS: 26,
  IE: 22,
  IL: 23,
  IT: 27,
  JO: 30,
  KZ: 20,
  XK: 20,
  KW: 30,
  LV: 21,
  LB: 28,
  LI: 21,
  LT: 20,
  LU: 20,
  MK: 19,
  MT: 31,
  MR: 27,
  MU: 30,
  MC: 27,
  MD: 24,
  ME: 22,
  NL: 18,
  NO: 15,
  PK: 24,
  PS: 29,
  PL: 28,
  PT: 25,
  QA: 29,
  RO: 24,
  SM: 27,
  SA: 24,
  RS: 22,
  SK: 24,
  SI: 19,
  ES: 24,
  SE: 24,
  CH: 21,
  TN: 24,
  TR: 26,
  AE: 23,
  GB: 22,
  VG: 24
};

function isLettersOnly(value: string): boolean {
  return /^[A-Z]+$/.test(value);
}

export const ibanValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const raw = (control.value ?? '').toString().trim();

  if (!raw) {
    return null;
  }

  const normalized = normalizeIban(raw);
  const countryCode = normalized.length >= 2 ? normalized.substring(0, 2) : '';
  const expectedLength = IBAN_LENGTHS_BY_COUNTRY[countryCode];

  if (!countryCode || countryCode.length !== 2 || !isLettersOnly(countryCode)) {
    return {
      invalidIban: true,
      invalidIbanMessage: 'IBAN måste börja med en landskod'
    };
  }

  if (!expectedLength) {
    return {
      invalidIban: true,
      invalidIbanMessage: 'Okänd landskod i IBAN'
    };
  }

  if (normalized.length !== expectedLength) {
    return {
      invalidIban: true,
      invalidIbanMessage: `IBAN ska vara ${expectedLength} tecken`
    };
  }

  if (!isValidIBAN(normalized)) {
    return {
      invalidIban: true,
      invalidIbanMessage: 'Ogiltigt IBAN'
    };
  }

  return null;
};